module.exports = __webpack_public_path__ + "img/BS12.dace54e9.svg";